import { render } from "./electricalConversion.vue?vue&type=template&id=23e86027&scoped=true"
import script from "./electricalConversion.vue?vue&type=script&lang=js"
export * from "./electricalConversion.vue?vue&type=script&lang=js"

import "./electricalConversion.vue?vue&type=style&index=0&id=23e86027&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e86027"]])

export default __exports__